import { render } from "./StockPhotoSelector.vue?vue&type=template&id=6246123a"
import script from "./StockPhotoSelector.vue?vue&type=script&lang=js"
export * from "./StockPhotoSelector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__